import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { container, heading1, heading2 } from 'app/sofia/resources/theme/css'
import { BREAKPOINT } from 'app/sofia/resources/constants'
import brandBottomBorder from 'resources/svg/brand-hero-border-bottom.svg'
import brandShape from 'resources/svg/brand-hero-shape.svg'
import filterSvg from 'resources/svg/icons/filter.svg'
import { Checkbox } from 'components/Checkbox'

interface Plp {
  isBrand?: boolean
}

export const Wrapper = styled.div<Plp>`
  background: ${props => props.theme.palette.general.soft};
  padding-bottom: 50px;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  z-index: 1;
`

export const Container = styled.div`
  ${container}

  h1 {
    ${heading1};
    display: inline-block;
  }

  .content-wrapper {
    &.is-brand {
      border-top: 1px solid ${(props: any) => props.theme.palette.general.greyMutted};
    }
  }

  .toolbar {
    > div {
      > div {
        button {
          display: flex;
          align-items: center;
          border: 1px solid ${props => props.theme.palette.general.strong};
          border-radius: 4px;
          background: ${props => props.theme.palette.general.light};
          padding: 2px 6px;
          font: ${font('default', 'bold', '14px/1')};
          margin-right: 20px;
          ${bp('sm', 'min-width')`
            display: none;
          `}

          &::before {
            content: '';
            display: inline-block;
            width: 15px;
            height: 16px;
            margin-right: 10px;
            background: url(${filterSvg}) no-repeat center;
          }
        }
      }
    }

    &,
    &__bottom {
      > div {
        background: transparent;
      }
    }
  }
`

export const Sidebar = styled.div`
  flex-basis: 20%;
  padding-right: 30px;
  margin-top: 10px;
  min-width: 288px;
  box-sizing: border-box;

  > h3 {
    font: ${font('default', 'bold', '20px')};
    margin-top: 10px;
  }

  input[type=checkbox] {
    ${Checkbox};
    color: ${props => props.theme.palette.general.strong};
    display: flex;
    align-items: center;
  }
`

export const ContentWrapper = styled.div`
  flex-basis: 80%;
  ${bp('sm')`
    flex-basis: 100%;
    max-width: 100%;

    h2 {
      border-top: 1px solid ${(props: any) => props.theme.palette.general.greyMutted};
      padding-top: 20px;
      margin-top: 5px;
    }
  `}
`

export const Shipping = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 30px;

  > svg {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }

  p {
    font: ${font('default', 'bold', '14px/1.6')};

    span {
      display: block;
      font: ${font('default', 'light', '14px/1.2')};
    }
  }
`

export const DescriptionWrapper = styled.div`
  width: 75%;
  max-width: 720px;
  margin: 20px auto;
  font: ${font('default', 'light', '14px/1.5')};
`

export const CategoryBlock = styled.div`
  img {
    width: 100%;
    height: auto;
  }
`
export const BrandHero = styled.div`
  .hero {
    position: relative;

    &__image {
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        display: block;
        width: 350px;
        height: 450px;
        background: url(${brandShape}) no-repeat center;
        position: absolute;
        bottom: -140px;
        left: -70px;

        @media (max-width: ${BREAKPOINT.MD}) {
          width: 250px;
          height: 350px;
          background-size: 250px;
          bottom: -100px;
        }

        ${bp('sm')`
          bottom: -200px;
        `}
      }

      &::after {
        content: '';
        display: block;
        background: url(${brandBottomBorder}) no-repeat bottom;
        background-size: 100vw;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
      }

      img {
        width: 100%;
        height: auto;
      }
    }

    &__overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      ${container}
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: ${props => props.theme.palette.general.light};
      ${bp('sm')`
        position: static;
        color: ${(props: any) => props.theme.palette.general.strong};
        justify-content: flex-start;
        text-align: center;
      `}

      h2 {
        ${heading2}
      }

      &-content {
        width: 30%;
        ${bp('lg')`
          width: 45%;
        `}

        @media (max-width: ${BREAKPOINT.MD}) {
          width: 65%;
        }

        ${bp('sm')`
          width: 100%;
        `}

        img {
          width: 160px;
          ${bp('sm')`
            width: 100px;
          `}
        }
      }
    }
  }
`

export const NoProducts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    margin: 20px 0;
  }
`

export const BreadcrumbsWrapper = styled.div`
  margin: 12px 0;
`
